export default __webpack_public_path__ + "static/media/popit.212b07a7.glb";